(() => {
  'use strict';
  const root = document.documentElement;
  const selector = '.ggx-warehouse .ggx-product-grid .ggx-product-card, .gg-15packs__grid .gg-15packs__card, collection-component .product-grid product-card.product-card, #gg-bab-formats .gg-bab-guide__formats > article';
  const visibleAttribute = 'data-gg-collection-rim-visible';
  const cards = new Set();
  const setPaused = paused => root.toggleAttribute('data-gg-collection-motion-paused', paused);
  try { setPaused(sessionStorage.getItem('ggx-living-motion-paused') === 'true'); } catch (_) { /* Storage may be unavailable. */ }
  window.addEventListener('ggx:motion-preference', event => setPaused(event.detail?.paused === true));
  const visibility = () => root.toggleAttribute('data-gg-collection-tab-hidden', document.hidden);
  document.addEventListener('visibilitychange', visibility);
  visibility();
  // Unsupported observers retain the static, accessible interaction rim.
  if (typeof IntersectionObserver !== 'function') return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.toggleAttribute(visibleAttribute, entry.isIntersecting));
  }, { threshold: 0 });
  const register = node => {
    if (!(node instanceof Element)) return;
    const add = card => { if (!cards.has(card)) { cards.add(card); observer.observe(card); } };
    if (node.matches(selector)) add(node);
    node.querySelectorAll(selector).forEach(add);
  };
  const main = document.querySelector('main') || document.body;
  register(main);
  // Warehouse feeds and native filtering replace cards without a full navigation.
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(register));
    cards.forEach(card => {
      if (!card.isConnected) { observer.unobserve(card); card.removeAttribute(visibleAttribute); cards.delete(card); }
    });
  }).observe(main, { childList: true, subtree: true });
})();
